import React from "react";
import {Route, Routes} from "react-router-dom";
import {BookingCreate} from "./BookingCreate";
import {BookingEdit} from "./BookingEdit";
import {BookingList} from "./BookingList";
import {BookingView} from "./BookingView";
import {BulkEndBookings} from "./BulkEndBookings";
import {BookingShareCreate} from "./share/BookingShareCreate";
import {BookingShareEdit} from "./share/BookingShareEdit";

export function Bookings() {
	return (
		<Routes>
			<Route index element={<BookingList />} />
			<Route path="new" element={<BookingCreate />} />
			<Route path="bulk-end" element={<BulkEndBookings />} />
			<Route path=":bookingId" element={<BookingView />} />
			<Route path=":bookingId/edit" element={<BookingEdit />} />
			<Route path=":bookingId/newShare" element={<BookingShareCreate />} />
			<Route path=":bookingId/shares/:bookingShareId/edit" element={<BookingShareEdit />} />
		</Routes>
	);
}
